.status-filter {
    width: 180px;
}
